import { FC } from 'react';
import {
  Stack,
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Center,
} from '@chakra-ui/react';
import { useEditDetailStore } from '../../../hooks';
import {
  AdhocSupportedIntervalCheckboxGroup,
  ConfigTemplateTextarea,
  DescriptionTextarea,
  ReleasedAtDatepicker,
  ReleasedChannelCheckboxGroup,
  VersionInput,
} from '../../Forms';

type Props = Pick<
  ReturnType<typeof useEditDetailStore>,
  | 'formState'
  | 'register'
  | 'control'
  | 'onOpenModalEditDetail'
  | 'onOpenModalDeleteDetail'
>;

export const CrawlerDetailInputModalView: FC<Props> = ({
  formState,
  register,
  control,
  onOpenModalEditDetail,
  onOpenModalDeleteDetail,
}) => (
  <Box p="32px">
    <Stack spacing="6" direction="column">
      <FormControl isRequired isInvalid={!!formState.errors.version}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            バージョン
          </FormLabel>
          <Box flex="1">
            <VersionInput
              name="version"
              register={register}
              w="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
            <FormErrorMessage>
              {formState.errors.version?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isRequired isInvalid={!!formState.errors.description}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            説明
          </FormLabel>
          <Box flex="1">
            <DescriptionTextarea
              name="description"
              register={register}
              rows={4}
            />
            <FormErrorMessage>
              {formState.errors.description?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isRequired isInvalid={!!formState.errors.releasedAt}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            リリース日
          </FormLabel>
          <Box flex="1">
            <ReleasedAtDatepicker
              name="releasedAt"
              control={control}
              inputProps={{ width: '240px' }}
            />
            <FormErrorMessage>
              {formState.errors.releasedAt?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            手動実行対応
          </FormLabel>
          <Box flex="1">
            <AdhocSupportedIntervalCheckboxGroup
              name="adhocSupportedIntervals"
              control={control}
            />
          </Box>
        </Stack>
      </FormControl>
      <FormControl isRequired isInvalid={!!formState.errors.configTemplate}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            UI表示テンプレート
          </FormLabel>
          <Box flex="1">
            <ConfigTemplateTextarea
              name="configTemplate"
              register={register}
              rows={8}
            />
            <FormErrorMessage>
              {formState.errors.configTemplate?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isRequired isInvalid={!!formState.errors.releasedChannel}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            リリースチャンネル
          </FormLabel>
          <Box flex="1">
            <ReleasedChannelCheckboxGroup
              name="releasedChannel"
              control={control}
              isInvalid={!!formState.errors.releasedChannel}
            />
            <FormErrorMessage>
              {
                // eslint-disable-next-line
                (formState.errors.releasedChannel as any)?.message
              }
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
    </Stack>
    <Center mt="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        isDisabled={!formState.isValid}
        onClick={onOpenModalEditDetail}
      >
        確認
      </Button>
    </Center>
    <Center mt="20px">
      <Button
        colorScheme="blackAlpha"
        variant="ghost"
        onClick={onOpenModalDeleteDetail}
      >
        このバージョンを削除
      </Button>
    </Center>
  </Box>
);
